import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterBonusReportView.
 * @extends JetView
 */
export default class FilterBonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for the country select
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Second dropdown for country selection
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for the country select
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile
                            readonly: true, // Read-only field
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        {
                            view: 'text', // Text input for Player ID
                            name: 'PlayerId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Cliente'), // Label for Player ID
                            labelPosition: 'top',
                            placeholder: _('ID Cliente'), // Placeholder text
                            invalidMessage: _('Client ID is required'), // Validation message
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'text', // Text input for Partner Bonus ID
                            name: 'PartnerBonusId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-id'></span>" + _('Partner Bono Id'), // Label for Partner Bonus ID
                            labelPosition: 'top',
                            placeholder: _('Bono ID'), // Placeholder text
                            invalidMessage: _('Partner Bonus Id is required'), // Validation message
                        },
                        {
                            view: 'richselect', // Dropdown for Bonus Type selection
                            name: 'BonusType',
                            minWidth: 200,
                            localId: 'bonusTypes:combo',
                            label: _('Tipo'), // Label for Bonus Type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: '', value: _('Todos') }, // Option for all types
                                { id: '2', value: _('Deposito') }, // Deposit option
                                { id: '3', value: _('No Deposito') }, // Non-deposit option
                                { id: '6', value: _('FreeBet') }, // FreeBet option
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for State selection
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for State
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                {
                                    id: '',
                                    value: _('Todos'), // Option for all states
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'), // Active option
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'), // Inactive option
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'), // Pending option
                                },
                                {
                                    id: 'R',
                                    value: _('Redimido'), // Redeemed option
                                },
                                {
                                    id: 'E',
                                    value: _('Expirado'), // Expired option
                                },
                                {
                                    id: 'L',
                                    value: _('Libre'), // Free option
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for Campaign Category selection
                            name: 'CampaingCategory',
                            minWidth: 200,
                            id: 'CampaingCategory',
                            label: _('Tipo de Campaña'), // Label for Campaign Category
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for Campaign Details selection
                            name: 'CampaingDetails',
                            minWidth: 200,
                            id: 'CampaingDetails',
                            label: _('Detalle de la Campaña'), // Label for Campaign Details
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section containing additional filters
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for advanced filters
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Content of advanced filters
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to add massive bonus
                    value: _('Añadir bono masivo'),
                    type: 'form',
                    width: screen == 'small' ? 150 : 200,
                    height: screen == 'small' ? 50 : 0,
                    hidden: !devConfig.getPermAction('bonusBalanceAddMassive', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-bonusBalanceAddMassive',
                    click: () => {
                        this.app.callEvent('addBonusBalance2:button', [{}]); // Event to add massive bonus
                    },
                },
                {
                    view: 'button', // Button to add bonus to balance
                    value: _('Añadir bono a saldo'),
                    type: 'form',
                    width: screen == 'small' ? 150 : 200,
                    height: screen == 'small' ? 50 : 0,
                    hidden: !devConfig.getPermAction('bonusBalanceAdd', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-bonusBalanceAdd',
                    click: () => {
                        this.app.callEvent('addBonusBalance:button', [{}]); // Event to add bonus to balance
                    },
                },
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button', // Button to consult the report
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        console.log(filterdata); // Log filter data
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                        $$('b1').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to add massive bonus
                            value: _('Añadir bono masivo'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('bonusBalanceAddMassive', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-bonusBalanceAddMassive',
                            click: () => {
                                this.app.callEvent('addBonusBalance2:button', [{}]); // Event to add massive bonus
                            },
                        },
                        {
                            view: 'button', // Button to add bonus to balance
                            value: _('Añadir bono a saldo'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('bonusBalanceAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-bonusBalanceAdd',
                            click: () => {
                                this.app.callEvent('addBonusBalance:button', [{}]); // Event to add bonus to balance
                            },
                        },
                    ],
                },
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear the second form
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').setValues(
                                    $$('myForm2').getCleanValues(), // Reset second form values
                                );
                                $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect); // Reset country selection
                                $$('Datepicker').setValue(''); // Clear datepicker
                            },
                        },
                        {
                            view: 'button', // Button to consult the report from the second form
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get second form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('bonusReport:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Upper section with filters
                                    accordion_section, // Advanced filters section
                                    buttons, // Buttons section
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Content of the scrollable view
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Content of the popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section1 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ajax().get(devConfig.geturlApi() + 'Report/getTypesCampaign', {
            error: function (text, data, XmlHttpRequest) {
                webix.message({
                    title: _('¡Mensaje!'), // Error message title
                    type: 'alert-error',
                    text: _('Ocurrio un error.'), // Error message text
                });
            },
            success: function (text, data, XmlHttpRequest) {
                text = JSON.parse(text); // Parse response text
                text.Data.Categories.forEach((category) => {
                    category.id = category.Id;
                    category.value = category.Description;
                    delete category.Description;
                    delete category.Id;
                });
                text.Data.DetailsCampaign.forEach((detail) => {
                    detail.id = detail.Id;
                    detail.value = detail.Description;
                    delete detail.Description;
                    delete detail.Id;
                });
                $$('CampaingCategory').define('options', text.Data.Categories); // Set options for campaign category
                $$('CampaingCategory').refresh(); // Refresh dropdown
                $$('CampaingDetails').define(
                    'options',
                    text.Data.DetailsCampaign, // Set options for campaign details
                );
                $$('CampaingDetails').refresh(); // Refresh dropdown
            },
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
